
import img1 from './assets/HomePagePics/Prices.webp'
import img2 from './assets/HomePagePics/Main.webp'
import img3 from './assets/HomePagePics/Main2.webp'
import img4 from './assets/HomePagePics/Kitchen.webp'
import img5 from './assets/HomePagePics/Bathroom.webp'
import img6 from './assets/HomePagePics/Bedroom.webp'
import img7 from './assets/HomePagePics/Entry.webp'
import img8 from './assets/HomePagePics/Garage.webp'
import img9 from './assets/HomePagePics/Outer.webp'
import img10 from './assets/HomePagePics/OuterBack.webp'
import img11 from './assets/HomePagePics/OuterBack2.webp'
import img12 from './assets/HomePagePics/Bedroom2.webp'
import img14 from './assets/HomePagePics/Kitchen2.webp'
import img15 from './assets/HomePagePics/Main3.webp'
import img16 from './assets/HomePagePics/Main4.webp'
import img17 from './assets/HomePagePics/Bathroom2.webp'
import img18 from './assets/HomePagePics/Community1.webp'
import img19 from './assets/HomePagePics/Community2.webp'
import img20 from './assets/HomePagePics/Community3.webp'
import img21 from './assets/HomePagePics/Community4.webp'


import card1img1 from './assets/FloorPlans/card1/Unit 101 Floorplan.webp'
import card1img2 from './assets/FloorPlans/card1/Unit 101 Main Level.webp'

import card2img1 from './assets/FloorPlans/card2/MasterBilt-237 Front St-Upper.webp'
import card2img2 from './assets/FloorPlans/card2/MasterBilt-237 Front St-Main.webp'

const homeImages = [
    {
        'id': 1,
        'original': img1,
        "thumbnail": img1,
        'originalClass': 'homeImgs',
    },
    {
        'id': 2,
        'original': img2,
        "thumbnail": img2,
        'originalClass': 'homeImgs'
    },
    {
        'id': 3,
        'original': img3,
        "thumbnail": img3,
        'originalClass': 'homeImgs'
    },
    {
        'id': 4,
        'original': img15,
        "thumbnail": img15,
        'originalClass': 'homeImgs'
    },
    {
        'id': 5,
        'original': img16,
        "thumbnail": img16,
        'originalClass': 'homeImgs'
    },
    {
        'id': 6,
        'original': img4,
        "thumbnail": img4,
        'originalClass': 'homeImgs'
    },
    {
        'id': 7,
        'original': img14,
        "thumbnail": img14,
        'originalClass': 'homeImgs'
    },
    {
        'id': 8,
        'original': img5,
        "thumbnail": img5,
        'originalClass': 'homeImgs'
    },
    {
        'id': 9,
        'original': img17,
        "thumbnail": img17,
        'originalClass': 'homeImgs'
    },
    {
        'id': 10,
        'original': img6,
        "thumbnail": img6,
        'originalClass': 'homeImgs'
    },
    {
        'id': 11,
        'original': img12,
        "thumbnail": img12,
        'originalClass': 'homeImgs'
    },
    {
        'id': 12,
        'original': img7,
        "thumbnail": img7,
        'originalClass': 'homeImgs'
    },
    {
        'id': 13,
        'original': img8,
        "thumbnail": img8,
        'originalClass': 'homeImgs'
    },
    {
        'id': 15,
        'original': img9,
        "thumbnail": img9,
        'originalClass': 'homeImgs'
    },
    {
        'id': 16,
        'original': img10,
        "thumbnail": img10,
        'originalClass': 'homeImgs'
    },
    {
        'id': 17,
        'original': img11,
        "thumbnail": img11,
        'originalClass': 'homeImgs'
    },
    {
        'id': 18,
        'original': img18,
        "thumbnail": img18,
        'originalClass': 'homeImgs'
    },
    {
        'id': 19,
        'original': img19,
        "thumbnail": img19,
        'originalClass': 'homeImgs'
    },
    {
        'id': 20,
        'original': img20,
        "thumbnail": img20,
        'originalClass': 'homeImgs'
    },
    {
        'id': 21,
        'original': img21,
        "thumbnail": img21,
        'originalClass': 'homeImgs'
    },

]

const floorPlanImages = [

    [
        {
            'original': card1img1,
            "thumbnail": card1img1,
            'originalClass': 'cardImgs'
        },
        {
            'original': card1img2,
            "thumbnail": card1img2,
            'originalClass': 'cardImgs'
        }
    ],
    [
        {
            'original': card2img1,
            "thumbnail": card2img1,
            'originalClass': 'cardImgs'
        },
        {
            'original': card2img2,
            "thumbnail": card2img2,
            'originalClass': 'cardImgs'
        }
    ]
]



export { homeImages, floorPlanImages }